import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-1727cffa"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "head-view"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "shadow"
}, null, -1));

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "round"
}, null, -1));

const _hoisted_4 = {
  class: "content-wrap"
};
const _hoisted_5 = {
  class: "right"
};
const _hoisted_6 = {
  class: "name"
};
import autoHidebar from '@/components/common/auto-hide-bar.vue';
import GlassView from '../common/glass-view.vue';
import composition from '@/composition';
import ua from '@/utils/platform';
export default {
  props: {
    model: Object
  },

  setup(__props) {
    const props = __props;
    const {
      ref,
      request,
      computed,
      loginHandle,
      navigateToWechatMiniProgram
    } = composition();
    const go2233 = ref(null);

    const handle_go2233 = () => {
      if (go2233.value) {
        go2233.value.commonClick2233();
      }
    }; // 关注状态


    const subscribeState = ref(null); // 参与人数

    const joinCount = computed(() => {
      return Number(props.model.commentCount) + Number(props.model.fansCount) + Number(props.model.postCount);
    }); // 是否展示关注按钮

    const showFollow = computed(() => {
      return props.model.id != 411;
    }); // 关注

    function follow(state) {
      if (ua.isMini) {
        navigateToWechatMiniProgram();
      } else {
        _Toast.loading({
          message: '操作中...',
          duration: 0,
          forbidClick: true
        });

        loginHandle().then(() => {
          request.followCategory(props.model.id, state).then(() => {
            _Toast.success('操作成功');

            subscribeState.value = state;

            if (state == true) {
              _poc_follow(props.model.name, props.model.id);
            }
          }).catch(() => {
            _Toast.fail('操作失败');
          });
        }).catch(() => {
          _Toast.fail('操作失败');
        });
      }
    }

    function _poc_follow(title, id) {
      // [埋点] 社区页访问
      let _poc_event_params = {
        channel_id: id,
        channel_name: title
      }; // eslint-disable-next-line no-undef

      qaplus.event.record('fsplusmp_community_channel_follow', 2101, _poc_event_params); // eslint-disable-next-line no-undef

      pocplus.event.record('fsplusmp_community_channel_follow', _poc_event_params);
    }

    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [__props.model.background ? (_openBlock(), _createBlock(GlassView, {
        key: 0,
        class: "bg",
        src: __props.model.background
      }, null, 8, ["src"])) : _createCommentVNode("", true), _hoisted_2, _hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(_component_van_image, {
        class: "icon",
        src: __props.model.icon,
        fit: "cover"
      }, null, 8, ["src"]), _createElementVNode("div", _hoisted_5, [_createElementVNode("p", _hoisted_6, _toDisplayString(__props.model.name), 1), _unref(ua).isFsPlus || _unref(ua).isMini ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [(subscribeState.value == null ? __props.model.subscribeState : subscribeState.value) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "followed-btn",
        onClick: _cache[0] || (_cache[0] = $event => follow(false))
      })) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "follow-btn",
        onClick: _cache[1] || (_cache[1] = $event => follow(true))
      }))], 64)) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "follow-btn",
        onClick: handle_go2233
      }))])])]), _createVNode(autoHidebar, {
        style: {
          "display": "none"
        },
        ref_key: "go2233",
        ref: go2233
      }, null, 512)], 64);
    };
  }

};